// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAbF3-S37xlaJKStncHYo4KfqSo_B0QwLo",
  authDomain: "my-saas-a9ed7.firebaseapp.com",
  projectId: "my-saas-a9ed7",
  storageBucket: "my-saas-a9ed7.firebasestorage.app",
  messagingSenderId: "24557492987",
  appId: "1:24557492987:web:55d576c4ecdfaccc706e5e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services (declare only once!)
export const auth = getAuth(app);
export const db = getFirestore(app);
